import { render, staticRenderFns } from "./issuesDialog.vue?vue&type=template&id=71acfc80&scoped=true&"
import script from "./issuesDialog.vue?vue&type=script&lang=js&"
export * from "./issuesDialog.vue?vue&type=script&lang=js&"
import style0 from "./issuesDialog.vue?vue&type=style&index=0&id=71acfc80&scoped=true&lang=scss&"
import style1 from "./issuesDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acfc80",
  null
  
)

export default component.exports